<script lang="ts">
    import KpMarkdown from 'shared/components/kp-markdown/KpMarkdown.svelte';

    export let markdown: string;
</script>

<div class="markdown-display">
    <KpMarkdown {markdown} block/>
</div>

<style lang="less">
    @import (reference) "./markdown.styles.less";

    .markdown-display {
        :global {
            .markdown-styles();
        }
    }
</style>
